// Previsão/Efetivo — "Ver itens" do fornecedor (treinamento turma 5, 20/10: Denise quer saber de que é cada
// fornecedor). A API manda `itens` em cada card, só os da Agência (D-0137): { id, nome, grupo_id, grupo_nome, etapa,
// valor, moeda }. Aqui só agrupa por grupo, na ordem em que os grupos aparecem, com subtotal por moeda.

export function agruparItensPorGrupo(itens = []) {
    const grupos = [];
    const porId = {};
    (Array.isArray(itens) ? itens : []).forEach((item) => {
        const chave = String(item.grupo_id || '');
        if (!porId[chave]) {
            porId[chave] = { grupo_id: chave, grupo_nome: item.grupo_nome || 'Grupo', itens: [], totais: {} };
            grupos.push(porId[chave]);
        }
        const grupo = porId[chave];
        grupo.itens.push(item);
        const moeda = item.moeda || 'real';
        grupo.totais[moeda] = Math.round(((grupo.totais[moeda] || 0) + Number(item.valor || 0)) * 100) / 100;
    });
    return grupos;
}

export function rotuloBotaoItens(itens = []) {
    const n = Array.isArray(itens) ? itens.length : 0;
    return n === 1 ? 'Ver item (1)' : `Ver itens (${n})`;
}
